import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { equals, toPairs, fromPairs } from 'ramda';

import { QueryRenderer } from "@cubejs-client/react";
import { isQueryPresent } from '@cubejs-client/core';


var defaultImportDate = '2019-12-21';

class ResultSet {
    constructor(data, dateField, mindate, maxdate, cardTypeFilter) {

        this.dateField = dateField;
        this.mindate = mindate;
        this.maxdate = maxdate;
        this.cardTypeFilter = cardTypeFilter;
        this.reportData = this.generateRawData(data);
    }

    rawData() {
        return this.reportData;
    }

    generateRawData(reportData) {

        var me = this;

        var importDate = moment(defaultImportDate);

        if(reportData.query && reportData.query.timeDimensions &&
            reportData.query.timeDimensions.length > 0 &&
            reportData.query.timeDimensions[0].dateRange &&
            reportData.query.timeDimensions[0].dateRange.length >= 2)
        {
            importDate = moment(reportData.query.timeDimensions[0].dateRange[1]);
        }

        var delta = moment().startOf('day') - importDate;

        const filteredByType = this.cardTypeFilter === 'both' ? reportData.data : reportData.data.filter(elem => elem['DimCard.type'] ? this.cardTypeFilter === elem["DimCard.type"]: true);

        return filteredByType.filter((elem) => {
            var etime = moment(elem[me.dateField]).add(delta, 'ms');

            return etime.isBetween(me.mindate, me.maxdate);
        }).map((elem) => {
            var newelem = {...elem};
            if(elem["FactSegment.startTime"])
                newelem["FactSegment.startTime"] = moment(elem["FactSegment.startTime"]).add(delta, 'ms');
            if(elem["FactSegment.endTime"])
                newelem["FactSegment.endTime"] = moment(elem["FactSegment.endTime"]).add(delta, 'ms');
            if(elem["FactEvent.timestamp"])
                newelem["FactEvent.timestamp"] = moment(elem["FactEvent.timestamp"]).add(delta, 'ms');
            if(elem["FactGeofenceState.startTime"])
                newelem["FactGeofenceState.startTime"] = moment(elem["FactGeofenceState.startTime"]).add(delta, 'ms');
            if(elem["FactGeofenceState.endTime"])
                newelem["FactGeofenceState.endTime"] = moment(elem["FactGeofenceState.endTime"]).add(delta, 'ms');
            if(elem["FactSegment2.startTime"])
                newelem["FactSegment2.startTime"] = moment(elem["FactSegment2.startTime"]).add(delta, 'ms');
            if(elem["FactSegment2.endTime"])
                newelem["FactSegment2.endTime"] = moment(elem["FactSegment2.endTime"]).add(delta, 'ms');

            return newelem;
        });

    }    
}

class FakeQueryRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
        this.mutexObj = {};
    }

    componentDidMount() {
        const { query, queries, loc } = this.props;
        
        if(query)
            this.load(query, loc);
        else if(queries && queries.length > 0){
            this.load(queries[0], loc);
        }
    }
    componentDidUpdate(prevProps) {
        const { query, queries, loc } = this.props;
        
        if(query){
            // deep(ish) compare
            if(JSON.stringify(prevProps.query) !== JSON.stringify(query))
            {
                this.load(query, loc);
            }
        }
        else if(queries && queries.length > 0){
            if(JSON.stringify(prevProps.queries[0]) !== JSON.stringify(queries[0]))
            {
                this.load(queries[0], loc);
            }
        }
    }

    load(query,loc) {

        var filter = query.filters && query.filters.length > 0 ? query.filters[0].values[0] : "both";

        if(!query.measures || query.measures[0] === "LatestRavenSegment.odometerInKilometers")
        {
            // Ravens
            this.fetchData(loc, 
                "ravenreportdata.json", 
                "LatestRavenSegment.endTime",
                '2018-01-01', // Hardcode the start time, only use end time
                '2099-01-01', // any time today
                filter
            );
        }
        else if(query.measures[0] === "FactSegment.distance")
        {
            // Trip
            this.fetchData(loc, 
                "tripreportdata.json", 
                "FactSegment.startTime",
                query.timeDimensions[0].dateRange[0],
                query.timeDimensions[0].dateRange[1],
                filter
            );
        }
        else if(query.measures[0] === "FactEvent.count")
        {
            // Event
            // Could be vehicle or driver
            let hasDriver = false;
            let hasVehicle = false;

            query.dimensions.forEach( (elem) => {
                if(elem === 'DimDriver.name')
                    hasDriver = true;
                if(elem === 'DimVehicle.name')
                    hasVehicle = true;
            });

            var reportFilename = "eventreportdata.json";

            if(hasDriver && hasVehicle)
            {
                // Both
            }
            else if(hasDriver)
            {
                // Driver Report
                reportFilename = "eventreportdriver.json";
            }
            else if(hasVehicle)
            {
                // Vehicle Report
                reportFilename = "eventreportvehicle.json";
            }

            this.fetchData(loc, 
                reportFilename,
                "FactEvent.timestamp",
                query.timeDimensions[0].dateRange[0],
                query.timeDimensions[0].dateRange[1],
                filter
            );
        }
        else if(query.measures[0] === "FactGeofenceState.durationInSeconds")
        {
            // Geofence
            this.fetchData(loc, 
                "geofencereportdata.json",
                "FactGeofenceState.startTime",
                query.timeDimensions[0].dateRange[0],
                query.timeDimensions[0].dateRange[1],
                filter
            );
        }
        else if(query.measures[0] === "FactSegment2.durationInSeconds")
        {
            // stops
            this.fetchData(loc, 
                "stopsreportdata.json",
                "FactSegment2.startTime",
                query.timeDimensions[0].dateRange[0],
                query.timeDimensions[0].dateRange[1],
                filter
            );
        }
        else if(query.measures[0] === "FactSegment2.distance")
        {
            // activities
            this.fetchData(loc, 
                "activityreportdata.json",
                "FactSegment2.startTime",
                query.timeDimensions[0].dateRange[0],
                query.timeDimensions[0].dateRange[1],
                filter
            );
        }
        else if(query.measures[0] === "FactDTC.count")
        {
            // dtc
            this.fetchData(loc, 
                "dtcreportdata.json",
                "FactSegment.startTime",
                '2023-01-01',
                query.timeDimensions[0].dateRange[1],
                filter
            );
        }
    }

    fetchData(loc, filename, dateField, mindate, maxdate, filter) {

        this.setState({ loading: true, resultSet: false, error: null });

        var baseurl = 'https://raven-apps.s3.amazonaws.com/demodata/' + loc + '/';

        if(!this.state.identities && !this.state.pendingIdentities)
        {
            this.setState({pendingIdentities: true });

            let url = baseurl + 'identities.json';             

            fetch(url) 
            .then((data) => {
                return data.json();
            }).then((json) => {
                this.setState({pendingIdentities: false, identities: json});
            })
            .catch((err) => {
                // leave pending identities true... won't try again
                return false;
            });

        }

        // Grab the data

        let url = baseurl + filename;

        fetch(url) 
        .then((data) => {
            return data.json();
        }).then((json) => {
            this.setState({ 
                loading: false, 
                reportData: new ResultSet(json, dateField, mindate, maxdate, filter)
            });
            return;
        })
        .catch((err) => {
            this.setState({ loading: false, error: err});
            return false;
        });

    }

    render() {
        if(!this.props.render)
            return null;

        return this.props.render({
            error: this.state.error,
            resultSet: this.state.reportData,
            historyUrlOverride: '/en/stats/history/2a1a1a1a1a2a/1', /* TODO: read this from report data json */
            loadingState: {
                isLoading: this.state.loading
            }
        });
    }
}

// Wrap the existing QueryRenderer to override the load method
export class WrappedQueryRenderer extends QueryRenderer {
    constructor(props) {
        super(props);
    }

    componentDidMount()
    {
        this._mounted = true;
        super.componentDidMount();
    }

    componentWillUnmount()
    {
        this._mounted = false;
        // super.componentWillUnmount();
    }

    // the load method to not call setState on unmounted component
  load(query) {
    const { resetResultSetOnChange } = this.props;
    this.setState({
      isLoading: true,
      error: null,
      sqlQuery: null,
      ...(resetResultSetOnChange ? { resultSet: null } : {})
    });
    const { loadSql } = this.props;
    const cubejsApi = this.cubejsApi();

    if (query && isQueryPresent(query)) {
      if (loadSql === 'only') {
        cubejsApi.sql(query, { mutexObj: this.mutexObj, mutexKey: 'sql' })
          .then(sqlQuery => this.setState({ sqlQuery, error: null, isLoading: false }))
          .catch(error => { 
                if(!this._mounted)
                {
                    return;
                }
                return this.setState({
                    ...(resetResultSetOnChange ? { resultSet: null } : {}),
                    error,
                    isLoading: false
                  });
            });
      } else if (loadSql) {
        Promise.all([
          cubejsApi.sql(query, { mutexObj: this.mutexObj, mutexKey: 'sql' }),
          cubejsApi.load(query, { mutexObj: this.mutexObj, mutexKey: 'query' })
        ]).then(([sqlQuery, resultSet]) => this.setState({
          sqlQuery, resultSet, error: null, isLoading: false
        }))
          .catch(error => { 
                if(!this._mounted)
                {
                    return;
                }
                return this.setState({
                    ...(resetResultSetOnChange ? { resultSet: null } : {}),
                    error,
                    isLoading: false
                  });
            });
      } else {
        cubejsApi.load(query, { mutexObj: this.mutexObj, mutexKey: 'query' })
          .then(resultSet => this.setState({ resultSet, error: null, isLoading: false }))
          .catch(error => { 
                if(!this._mounted)
                {
                    return;
                }
                return this.setState({
                    ...(resetResultSetOnChange ? { resultSet: null } : {}),
                    error,
                    isLoading: false
                  });
            });
      }
    }
  }

  loadQueries(queries) {
    const cubejsApi = this.cubejsApi();
    const { resetResultSetOnChange } = this.props;
    this.setState({
      isLoading: true,
      ...(resetResultSetOnChange ? { resultSet: null } : {}),
      error: null
    });

    const resultPromises = Promise.all(toPairs(queries).map(
      ([name, query]) => cubejsApi.load(query, { mutexObj: this.mutexObj, mutexKey: name }).then(r => [name, r])
    ));

    resultPromises
      .then(resultSet => this.setState({
        resultSet: fromPairs(resultSet),
        error: null,
        isLoading: false
      }))
      .catch(error => { 
            if(!this._mounted)
            {
                return;
            }
            return this.setState({
                ...(resetResultSetOnChange ? { resultSet: null } : {}),
                error,
                isLoading: false
              });
        });
  }

}

export default class MyQueryRenderer extends React.Component {

    render() {

        if(this.props.user.original['custom:demo'])
        {
            return ( <FakeQueryRenderer {...this.props}
                        loc={this.props.user.original['custom:demo'] } /> );
        }
        else
        {
            return ( <WrappedQueryRenderer {...this.props} /> );
        }
    }

};
